module.exports = __webpack_public_path__ + "files/7fe3433a6c88675cb362cb703959b18c.png";